export const OPEN_LIVE_CHAT_HASH = '#livechat-open';
export const OPEN_LIVE_CHAT_QUERY_PARAM = 'chat';
export const LIVE_CHAT_STARTED_COOKIE = 'livechatChatStarted';
export const SESSION_COOKIE_OPTIONS =
    process.env.NODE_ENV !== 'development' ? { path: '/', domain: 'telia.lt', secure: true } : {};
